__webpack_require__.p = "/dev/create-a-test-file-for-labelrect/";